import { SelectOption } from '../../components'
import { useLocalizedMessages } from './useLocalizedMessages'

export const useLocalizedPaymentOptions = () => {
  const localizedPaymentOptionList = useLocalizedMessages(
    'localizedPaymentOptionList'
  )

  return localizedPaymentOptionList as SelectOption[]
}
